import React, {Component} from 'react'
import styles from './ListItem.css'
import Observer from 'react-intersection-observer'
import Svg from '../Svg/Svg'
import PropTypes from "prop-types"
import {isDesktop} from '../../services/service-utils'
import {TypeListItem} from "../../constants/consts-prop-types"
import {Icon, ListLayoutType} from '../../constants/consts-types'
import {getRandomPlaceholderImageUrl} from '../../services/service-utils'
import Sticker from "../Sticker/Sticker"
import DataTable from "../DataTable/DataTable"
import LinkDuo from "../LinkDuo/LinkDuo"
import {loadImage} from "../../services/service-image-loader"

class ListItem extends Component {
  static propTypes = {
    index: PropTypes.number,
    columnIndex: PropTypes.number,
    isDesktop: PropTypes.bool.isRequired,
    equalizeHeightsInRow: PropTypes.func.isRequired,
    data: TypeListItem,
    layout: PropTypes.string
  }

  static defaultProps = {
    layout: ListLayoutType.GRID
  }

  constructor(props) {
    super(props)

    this.parseAndLoadImage = this.parseAndLoadImage.bind(this)
    this.onImageLoaded = this.onImageLoaded.bind(this)
    this.dispatchImageHeight = this.dispatchImageHeight.bind(this)

    this.state = {
      imageSrc: null,
      imageHeight: 0,
      image: null
    }
  }

  componentDidMount() {
    this.parseAndLoadImage()
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.dispatchImageHeight)
  }

  componentDidUpdate(prevProps) {
    if(this.props.data.image_url !== prevProps.data.image_url) {
      this.parseAndLoadImage()
    }
  }

  parseAndLoadImage() {
    const {
      image_url,
      image,
    } = this.props.data

    const smallImage = image && image.sizes && image.sizes.medium_large ? image.sizes.medium_large : null
    const largeImage = image_url ? image_url : getRandomPlaceholderImageUrl()
    const imageUrl = smallImage ? smallImage : largeImage

    loadImage(imageUrl, this, this.onImageLoaded)
  }

  onImageLoaded(image) {
    this.setState({
      image: image
    }, () => {
      const {equalizeHeightsInRow} = this.props
      if(equalizeHeightsInRow) {
        // prevent double listeners if new image is loaded:
        window.removeEventListener('resize', this.dispatchImageHeight)
        window.addEventListener('resize', this.dispatchImageHeight)

        this.dispatchImageHeight()
      }
    })
  }

  dispatchImageHeight() {
    if(!this.nodeMain) return

    const {image} = this.state

    const {equalizeHeightsInRow, index, layout} = this.props

    const {width, height} = image
    const containerWidth = this.nodeMain.clientWidth
    const imageDisplayHeight = (containerWidth / width) * height

    if(isDesktop() || layout === ListLayoutType.SLIDER) equalizeHeightsInRow(index, imageDisplayHeight)

    this.setState({
      imageHeight: imageDisplayHeight
    })
  }

  render() {
    const {
      isDesktop,
      columnIndex,
      layout
    } = this.props

    const {
      category,
      header_bold,
      header_light,
      manchet,
      url,
      data_list,
      download,
      imageContainerHeightEqualized
    } = this.props.data

    const {
      imageSrc,
      imageHeight
    } = this.state

    const isSliderLayout = layout === ListLayoutType.SLIDER

    const styleImageContainer = {
      height: imageContainerHeightEqualized ? `${imageContainerHeightEqualized}px` : 'auto',
      transitionDelay: `${columnIndex * 2}00ms`,
      maxHeight: isSliderLayout ? 'calc(100vw / 14 * 12)' : ''
    }

    const styleBackgroundImage = imageSrc ? {
      backgroundImage: `url(${imageSrc})`,
      height: isDesktop && imageHeight ? imageHeight : '',
    } : {}

    const styleImageLink = {
      maxHeight: isSliderLayout ? 'calc(100vw / 14 * 12)' : ''
    }

    return (
      <div ref={(node) => (this.nodeMain = node)} className={styles.ListItem}>
        <Observer>
          {({ inView, ref }) => (
            <div
              ref={ref}
              className={
                inView ? styles.imageContainerInView : styles.imageContainer
              }
              style={styleImageContainer}
            >
              {imageSrc && (
                <React.Fragment>
                  <LinkDuo
                    to={url}
                    download={download}
                    className={styles.backgroundImage}
                    aria-label={header_bold}
                    style={styleBackgroundImage}
                    headerBold={header_bold}
                  />
                  <LinkDuo
                    to={url}
                    download={download}
                    className={styles.placeholderImage}
                    style={styleImageLink}
                    aria-label={header_bold}
                    headerBold={header_bold}
                  >
                    <img
                      src={imageSrc}
                      className={styles.imageTag}
                      alt={header_bold}
                    />
                  </LinkDuo>
                </React.Fragment>
              )}

              {download && (
                <Sticker className={styles.sticker}>
                  <span>Download</span>
                  <Svg id={Icon.DOWNLOAD} />
                </Sticker>
              )}
            </div>
          )}
        </Observer>

        <div className={styles.itemContent}>
          <small className={styles.category}>{category}</small>
          <LinkDuo
            to={url}
            className={styles.itemLink}
            download={download}
            aria-label={header_bold}
            headerBold={header_bold}
          >
            {header_bold && (
              <h3 dangerouslySetInnerHTML={{ __html: header_bold }} />
            )}
            {header_light && (
              <h3
                className="secondary"
                dangerouslySetInnerHTML={{ __html: header_light }}
              />
            )}
          </LinkDuo>
          {manchet && (
            <small
              className={styles.manchet}
              dangerouslySetInnerHTML={{ __html: manchet }}
            />
          )}

          {data_list && data_list.length > 0 && <DataTable items={data_list} />}

          {url && (
            <LinkDuo
              to={url}
              className={styles.itemLink}
              download={download}
              aria-label={header_bold}
              headerBold={header_bold}
            >
              <div className={styles.arrowContainer}>
                <Svg id={Icon.ARROW_LONGER_RIGHT} className={styles.arrow} />
              </div>
            </LinkDuo>
          )}
        </div>
      </div>
    );
  }
}

export default ListItem;



// WEBPACK FOOTER //
// ./src/components/ListItem/ListItem.js